<div [id]="chartContainerId"  [style.height.px]="companyId === 4 ? 200 : (companyId === 20 ? 600 : 400)" style="width: 100%;"></div>